export default __webpack_public_path__ + "static/media/edit-icon.56aae803.svg";